// extracted by mini-css-extract-plugin
export default {"Form":"SearchForm_Form__k4gvz","CoverTable":"SearchForm_CoverTable__AFI+Y"};